import {convertLocalDateToDate} from "crqlar-react-common/dist/utils/date.util";

export const ageFromBirthday = (
    birthday: string | Date | undefined,
    today = new Date(),
): number | undefined => {
    const birthDate = birthday instanceof Date ? birthday : convertLocalDateToDate(birthday);
    if (!birthDate) return undefined;

    let age = today.getFullYear() - birthDate.getFullYear();
    const birthdayHasPassed = today.getMonth() > birthDate.getMonth()
        || (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    if (!birthdayHasPassed) age -= 1;
    return age >= 0 ? age : undefined;
};
